export const search = "/search";
